var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',{staticClass:"suaw-thumbnail",class:[
    'suaw-thumbnail--' + _vm.size,
    'suaw-thumbnail--' + _vm.radius,
    _vm.className
  ]},[_c('img',{staticClass:"suaw-thumbnail__image",attrs:{"src":_vm.content,"alt":_vm.imageAlt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }